var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":_vm.imgUrl}}),_c('h1',[_vm._v(_vm._s(_vm.head))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":_vm.closePage}},[_vm._v("我知道了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }